import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const navItems = [{
  label: 'Inicio',
  href: 'inicio'
}, {
  label: 'Contenido',
  href: 'contenido'
}, {
  label: 'Testimonios',
  href: 'testimonios'
}, {
  label: 'Bonos',
  href: 'bonos'
}, {
  label: 'FAQ',
  href: 'faq'
}, {
  label: 'Precio',
  href: 'precio'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (sectionId: string) => {
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 60;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <>
      <motion.header initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.3
    }} className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white'}`} data-id="element-106">
        <div className="max-w-7xl mx-auto px-3 md:px-4" data-id="element-107">
          <div className="flex items-center justify-between h-14 md:h-20" data-id="element-108">
            {/* Logo */}
            <button onClick={() => scrollToSection('inicio')} className="flex-shrink-0" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/3ZT2DzuoRvji2HYounmzfj/Screenshot_2025-12-28_at_5.37.21_PM.png" alt="Hydra Gloss Lips" className="h-9 md:h-12 w-auto" data-id="element-110" />
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-6" data-id="element-111">
              {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="text-[#3D3028] hover:text-[#E5A5A0] transition-colors text-sm font-medium" data-id="element-112">
                  {item.label}
                </button>)}
              <button onClick={() => scrollToSection('precio')} className="bg-[#E5A5A0] hover:bg-[#d99590] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors" data-id="element-113">
                Inscribirse
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-[#3D3028]" aria-label="Toggle menu" data-id="element-114">
              <svg className="w-5 h-5" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor" data-id="element-115">
                {isMobileMenuOpen ? <path d="M6 18L18 6M6 6l12 12" data-id="element-116" /> : <path d="M4 6h16M4 12h16M4 18h16" data-id="element-117" />}
              </svg>
            </button>
          </div>
        </div>
      </motion.header>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-118">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="fixed top-14 md:top-20 left-0 right-0 z-30 bg-white border-b border-[#D4C4B0]/20 lg:hidden" data-id="element-119">
            <nav className="max-w-7xl mx-auto px-3 py-3 flex flex-col gap-1" data-id="element-120">
              {navItems.map(item => <button key={item.href} onClick={() => scrollToSection(item.href)} className="text-[#3D3028] hover:text-[#E5A5A0] transition-colors text-sm font-medium py-2.5 text-left" data-id="element-121">
                  {item.label}
                </button>)}
              <button onClick={() => scrollToSection('precio')} className="bg-[#E5A5A0] hover:bg-[#d99590] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors mt-1 text-center" data-id="element-122">
                Inscribirse
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}